'use strict';

var ModulesUtils = {
  //add new modules and fields here
  /*
  every module should have:
  1. searchable: boolean
  2. indexable: boolean
  3. path(unformattedEvent, eventId,  teamId){
      get value based on this info. unformattedEvent is event from firebaseDb with
      commone and extended info
     }
  4. format(value){
      value is the output of path function. format data in necessary way
     }
  */
  processor: {
    objectID: {
      searchable: false,
      indexable: true,
      path: function path(unformattedEvent, eventId, teamId, teamInfo) {
        return eventId;
      },
      format: function format(value) {
        return value;
      }
    },
    eventId: {
      searchable: false,
      indexable: true,
      path: function path(unformattedEvent, eventId, teamId, teamInfo) {
        return eventId;
      },
      format: function format(value) {
        return value;
      }
    },
    teamId: {
      searchable: false,
      indexable: true,
      path: function path(unformattedEvent, eventId, teamId, teamInfo) {
        return teamId;
      },
      format: function format(value) {
        return value;
      }
    },
    dateInfo: {
      searchable: true,
      indexable: true,
      path: function path(unformattedEvent, eventId, teamId, teamInfo) {
        var commonInfo = unformattedEvent.commonInfo.modules;
        return commonInfo && commonInfo.date;
      },
      format: function format(value) {
        return value;
      }
    },
    address: {
      searchable: true,
      indexable: true,
      path: function path(unformattedEvent, eventId, teamId, teamInfo) {
        var commonInfo = unformattedEvent.commonInfo.modules;
        return commonInfo && commonInfo.address && commonInfo.address.value;
      },
      format: function format(value) {
        return value;
      }
    },
    contactInfo: {
      searchable: true,
      indexable: true,
      path: function path(unformattedEvent, eventId, teamId, teamInfo) {
        var commonInfo = unformattedEvent.commonInfo.modules;
        if (commonInfo && commonInfo.contactInfo && (commonInfo.contactInfo.email || commonInfo.contactInfo.id || commonInfo.contactInfo.name || commonInfo.contactInfo.phoneNumber)) {
          return commonInfo.contactInfo;
        };
      },
      format: function format(value) {
        return value;
      }
    },
    description: {
      searchable: true,
      indexable: true,
      path: function path(unformattedEvent, eventId, teamId, teamInfo) {
        var commonInfo = unformattedEvent.commonInfo.modules;
        return commonInfo && commonInfo.description && commonInfo.description.value;
      },
      format: function format(value) {
        return value;
      }
    },
    displayName: {
      searchable: true,
      indexable: true,
      path: function path(unformattedEvent, eventId, teamId, teamInfo) {
        var commonInfo = unformattedEvent.commonInfo.modules;
        return commonInfo && commonInfo.displayName && commonInfo.displayName.value;
      },
      format: function format(value) {
        return value;
      }
    },
    tasks: {
      searchable: true,
      indexable: true,
      path: function path(unformattedEvent, eventId, teamId, teamInfo) {
        //TODO recurrent tasks
        var extendedInfo = unformattedEvent.extendedInfo && unformattedEvent.extendedInfo.modules;
        return extendedInfo && extendedInfo.tasks && extendedInfo.tasks.list;
      },
      format: function format(value) {
        return value;
      }
    },
    workers: {
      searchable: true,
      indexable: true,
      path: function path(unformattedEvent, eventId, teamId, teamInfo) {
        var module = unformattedEvent.commonInfo.modules['workers'];
        //console.log('teamInfo', teamInfo)
        if (module && module.list) {
          var workers = [];
          var members = teamInfo && teamInfo.members;
          if (members) {
            Object.keys(module.list).forEach(function (workerId) {
              var worker = members[workerId];
              if (worker) {
                workers.push(worker.displayName);
              }
            });
            return workers;
          }
        }
        return;
      },
      format: function format(value) {
        return value;
      }
    }
  },

  /*
    parameters =>
    eventId : string
    unformattedEvent: {eventId: {commonInfo: {metadata: teamId}}}
    teamId : string
    teamInfo : {members: {}, metadata: {}}
     returns =>
    eventInfo: {
      objectId: {value},
      teamId: {value},
      dateStr: {value},
      address: {value},
      contactInfo: {value},
      date: {value},
      time: {value},
      description: {value},
      displayName: {value},
      materials: {value},
      tasks: {value},
      workers: {value},
      notesExtended: {value}
    }
  */

  formatEventData: function formatEventData(eventData, eventId, teamId, teamData) {
    var formattedEvent = {};
    for (var moduleKey in ModulesUtils.processor) {
      var moduleSettings = ModulesUtils.processor[moduleKey];
      var moduleValue = moduleSettings.path(eventData, eventId, teamId, teamData);
      if (moduleValue) {
        formattedEvent[moduleKey] = moduleSettings.format(moduleValue);
      }
    }
    return formattedEvent;
  }
};

module.exports = ModulesUtils;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/ModulesUtils.js
// module id = 1041
// module chunks = 0